























































































































import { Component, PropSync, Prop, Ref, Vue } from "vue-property-decorator";
import store from "@/store";
import moment from "moment";
//  @types
import { VesselEvent } from "@/types/vesselEvent";
import { ExtendedVessel } from "@/types/vessel";
//  @modules
import { getModule } from "vuex-module-decorators";
import VesselsModule from "@/store/clients/Vessels.module";
import VesselEventsModule from "@/store/clients/VesselEvents.module";
import SnackbarModule from "@/store/clients/Snackbar.module";

const Vessels = getModule(VesselsModule, store);
const VesselEvents = getModule(VesselEventsModule, store);
const Snackbar = getModule(SnackbarModule, store);

@Component({})
export default class ManageEventsModal extends Vue {
  @PropSync("value", { required: true, type: Boolean, default: false }) isModalActive!: boolean;
  @Prop({ type: String, default: "760px" }) width!: string;

  //  @Data
  headers = [
    { text: "Event Name and Type", align: "start", sortable: false, value: "name" },
    { text: "Event Date", align: "start", sortable: false, value: "date", width: "130px" },
    { text: "Event Origin", align: "start", sortable: false, value: "origin", width: "190px" },
    { text: "Actions", align: "start", sortable: false, value: "actions" },
  ];

  //  @Getters
  get currentVessel(): ExtendedVessel | null {
    return Vessels.currentVessel;
  }

  get events(): VesselEvent[] {
    return VesselEvents.allEvents;
  }

  get rows(): any[] {
    const rows: any[] = [];

    this.events.forEach(event => {
      rows.push({
        event,
        date: event.timestamp,
        name: event.name,
        type: event.type,
        origin: event.source,
        actions: ["edit", "delete"],
      });
    });

    return rows;
  }

  //  @Methods
  open(): void {
    this.isModalActive = true;
  }

  close(): void {
    this.isModalActive = false;
  }

  deleteEvent(event: VesselEvent): void {
    this.$emit("delete", event);
  }

  edit(event: VesselEvent): void {
    this.$emit("edit", event);
  }

  formatEventDate(date: string): string {
    return moment.utc(date).format("D MMM YYYY");
  }

  isDockingName(name: string): boolean {
    return name === "Start Docking (w/Hull Cleaning)" || name === "Finish Docking (w/Hull Cleaning)";
  }

  async fetchEvents(): Promise<void> {
    if (!this.currentVessel?.id) return Promise.reject();
    try {
      VesselEvents.fetchEvents(this.currentVessel.id);
    } catch (error) {
      Snackbar.showSnackbar({ text: "Failed to fetch vessel events" });
    }
  }

  //  @Hooks
  async created(): Promise<void> {
    this.fetchEvents();
  }
}
